import { SET_COUNTRY, SET_LANGUAGE, SET_BACK_BUTTON, SET_COUNTRIES } from '@/utils/store/mutationTypes'

export default {
  /**
   * Sets the current country
   *
   * @param state
   * @param country
   */
  [SET_COUNTRY] (state, country) {
    if (state.countries.includes(country)) {
      state.country = country
    }
  },

  /**
   * Sets the current language
   *
   * @param state
   * @param locale
   * @constructor
   */
  [SET_LANGUAGE] (state, locale) {
    if (state.locales.includes(locale)) {
      state.locale = locale
    }
  },

  /**
   * Sets the return page for the back button component.
   *
   * @param state
   * @param page
   */
  [SET_BACK_BUTTON] (state, { visible, text, to, click }) {
    state.backButton.visible = visible
    state.backButton.to = to || null
    state.backButton.click = click || (() => {})
    state.backButton.text = text
  },
  [SET_COUNTRIES] (state, countriesData) {
    state.countriesData = countriesData
  }
}
